/** Adapter-side fallback: a read-only registry over a flat, connect-time ClientTools snapshot. */
import type {
  ClientTool,
  ClientToolRegistry,
  ClientTools,
} from "@microsoft/voice-widget-core-client";

export function wrapStatic(tools: ClientTools | undefined): ClientToolRegistry {
  return {
    register(): () => void {
      throw new Error("provider-voicelive: static client-tool snapshot is read-only");
    },
    get(name: string): ClientTool | undefined {
      // Own-property only: never resolve inherited names (toString/constructor/__proto__)
      // as tools — that would let the agent invoke functions the host never registered.
      if (!tools || !Object.prototype.hasOwnProperty.call(tools, name)) return undefined;
      return tools[name];
    },
    list(): string[] {
      return tools ? Object.keys(tools) : [];
    },
  };
}
